import dayjs from "dayjs";
import _ from "lodash";

export function formatDateWithDayOfWeek(date: string | Date): string {
  return _.capitalize(dayjs(date).format("dddd, DD/MM/YYYY"));
}

export function formatTimeRange(
  start: string | Date,
  end: string | Date
): string {
  return `${dayjs(start).format("HH:mm")} - ${dayjs(end).format("HH:mm")}`;
}
